export const USERS_STALE_TIME = 1000 * 60 * 5;
export const ALL_PROFILES_QUERY_KEY = ["allProfiles"] as const;
